import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Protects routes - redirects to login if not authenticated.
 * Also handles session expiry: when Supabase auth expires, user is redirected to login.
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-canvas dark:bg-canvas-dark" role="status" aria-label="Loading">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-line dark:border-line-dark border-t-forest-ondark dark:border-t-forest motion-reduce:animate-none"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login, saving the attempted URL for redirect after login
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
